import { Tiles } from "../../../../src/blocks";
import SEO from "../../../../src/components/seo";
import * as React from 'react';
export default {
  Tiles,
  SEO,
  React
};